<app-view-item *ngIf="disabled" [text]="selected?.reportLabel"></app-view-item>
<nz-select *ngIf="!disabled"
  nzShowSearch
  nzServerSearch
  [nzAllowClear]="true"
  [nzFilterOption]="nzFilterOption"
  (nzOnSearch)="search($event)"
  (nzOpenChange)="search('')"
  [nzCustomTemplate]="displayTpl"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  [nzDropdownRender]="loadingTpl"
  [nzBorderless]="borderless"
  nzDropdownClassName="sst-dropdown"
  class="width-100"
>
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>

  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="o.id" [nzLabel]="o.reportLabel" nzCustomContent>
        <b>From: </b> {{ o.taxableDateFrom | date: dateFormatService.currentDateFormatValue }} <br />
        <b>To: </b> {{ o.taxableDateTo | date: dateFormatService.currentDateFormatValue }} <br />
        <nz-tag *ngIf="o.type == 0" [nzColor]="'blue'">SALES</nz-tag>
        <nz-tag *ngIf="o.type == 1" [nzColor]="'green'">SERVICE</nz-tag>
    </nz-option>
  </ng-container>

</nz-select>

<ng-template #loadingTpl>
  <div *ngIf="searching">
    <nz-spin></nz-spin>
    Loading
  </div>
</ng-template>
